import { ArticleContentItem } from './resourceContentUtils';
import { ArticleHeadline } from './articleContentItems/ArticleHeadline';
import { ArticleText } from './articleContentItems/ArticleText';
import { ArticleImage } from './articleContentItems/ArticleImage';
import { ArticleBullets } from './articleContentItems/ArticleBullets';
import { ArticleGallery } from './articleContentItems/ArticleGallery';

interface FieldRendererProps {
  articleContentItem: ArticleContentItem;
  className?: string;
}

export const ArticleContentItemRenderer = ({
  articleContentItem,
  className,
}: FieldRendererProps) => {
  // Wrapper div to apply className if provided
  const Wrapper = ({ children }: { children: React.ReactNode }) =>
    className ? <div className={className}>{children}</div> : <>{children}</>;

  return (
    <Wrapper>
      {(() => {
        switch (articleContentItem.acf_fc_layout) {
          case 'mp_headline':
            return (
              <ArticleHeadline
                headline={articleContentItem.headline_text}
                headlineType={articleContentItem.headline_type}
              />
            );
          case 'mp_bullets_test':
            return <ArticleBullets bullets={articleContentItem.bullets} />;
          case 'mp_bullets2':
            return <ArticleBullets bullets={articleContentItem.bullets} />;
          case 'mp_bullets':
            return <div>TO BE IMPLEMENTED</div>;
          case 'mp_textarea':
            return <ArticleText text={articleContentItem.mp_text} />;
          case 'mp_img':
            return <ArticleImage url={articleContentItem.img_single} />;
          case 'mp_gallery':
            return (
              <ArticleGallery images={articleContentItem.mp_gallery_images} />
            );
          default:
            return null;
        }
      })()}
    </Wrapper>
  );
};
